import './AdminPanel.scss';
import * as React from 'react';
import { connect } from 'react-redux';
import { AppState } from 'app/store';
import { getAuthenticatingUser, getSessionUser } from 'app/stateHelpers';
import * as Core from 'components/core';
import UserSwitcher from 'components/admin/UserSwitcher';
import SwitchUser from 'app/actionCreators/SwitchUser';
import { LinkButton } from '@/react-ui';
type State = {
  expanded: boolean;
};
function mapAppStateToProps(appState: AppState): AppState {
  return appState;
}
class AdminPanel extends React.Component<AppState, State> {
  state = {
    expanded: false,
  };
  toggle = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    this.setState({
      expanded: !this.state.expanded,
    });
  };
  stopImpersonating = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    const authenticatingUser = getAuthenticatingUser(this.props);
    const hasAdminPrivileges =
      authenticatingUser && authenticatingUser.AdminLevel > 0;
    if (!hasAdminPrivileges || authenticatingUser == null) {
      return;
    }
    const sessionUser = getSessionUser(this.props);
    if (sessionUser == null) {
      return;
    }
    SwitchUser(authenticatingUser.LoginEmail, sessionUser);
  };
  render() {
    const authenticatingUser = getAuthenticatingUser(this.props);
    const hasAdminPrivileges =
      authenticatingUser && authenticatingUser.AdminLevel > 0;
    if (!hasAdminPrivileges || authenticatingUser == null) {
      return null;
    }
    const { expanded } = this.state;
    const sessionUser = getSessionUser(this.props);
    if (sessionUser == null) {
      return null;
    }
    const impersonating = sessionUser.ID !== authenticatingUser.ID;
    const classNames = [
      'AdminPanel',
      expanded && 'expanded',
      impersonating && 'impersonating',
    ]
      .filter(Boolean)
      .join(' ');
    return (
      <div className={classNames}>
        <div className="AdminPanel-HUD">
          {impersonating && (
            <div className="AdminPanel-HUD-viewingAs">
              Navigating site as {sessionUser.LoginEmail} -{' '}
              <LinkButton
                className="underline"
                onClick={this.stopImpersonating}
              >
                switch back to {authenticatingUser.LoginEmail}
              </LinkButton>
            </div>
          )}
          {!impersonating && expanded && (
            <div className="AdminPanel-HUD-viewingAs">
              Admin Panel for {authenticatingUser.LoginEmail}
            </div>
          )}
          <div className="AdminPanel-HUD-toggle">
            <Core.Button textLink onClick={this.toggle}>
              {expanded ? 'Close' : 'Admin Panel'}
            </Core.Button>
          </div>
        </div>
        {expanded && (
          <div className="AdminPanel-controls">
            <UserSwitcher
              authenticatingUser={authenticatingUser}
              currentUser={sessionUser}
            />
          </div>
        )}
      </div>
    );
  }
}
export default connect(mapAppStateToProps)(AdminPanel);
